export default __webpack_public_path__ + "static/media/alerts.beb9d9b2.png";